<template>
    <div class="pt-4">
        <v-select
            v-model="formData.currency"
            :items="useCurrency"
            :label="$t('currency')"
            :rules="[requiredRule('currency')]"
            data-cy="currency"
            max-width="200"
        />
        <TreeViewCalculation
            v-model="formData.pricingRuleRoot"
            :is-show-mark-up="true"
            :is-show-calculation-commission="isShowCalculationCommission"
            :currency="formData.currency"
        />
        <div class="text-subtitle-1 pb-3">{{ $t('perform_sales') }}</div>
        <v-radio-group v-model="formData.performSalesMode">
            <v-radio
                v-for="{value, title} in usePerformSalesMode"
                :key="value"
                :label="title"
                :value="value"
                :data-cy="value"
            />
        </v-radio-group>
        <v-checkbox
            v-model="formData.roundUpPrices"
            :label="$t('round_up_client_prices')"
            data-cy="round-up-client-prices"
            hide-details
        />
        <v-radio-group v-if="formData.roundUpPrices" v-model="formData.roundUpCommission">
            <v-radio :label="$t('round_up_commission')" :value="true" data-cy="round-up-commission" />
            <v-radio :label="$t('not_round_up_commission')" :value="false" data-cy="not-round-up-commission" />
        </v-radio-group>
        <v-checkbox
            v-if="isShowCalculationCommission"
            v-model="formData.applyCommissionToCancelledService"
            :label="$t('apply_commission_to_cancelled_service')"
            data-cy="apply-commission-to-cancelled-service"
        />
    </div>
</template>
<script setup lang="ts">
    import {requiredRule} from '~/composables/rules'
    import TreeViewCalculation from '~/components/salesSettings/TreeViewCalculation.vue'

    const formData = defineModel<any>()

    const isShowCalculationCommission = inject('isShowCalculationCommission', ref(false))

    const {t} = useI18n()

    const usePerformSalesMode = computed(() => {
        return [
            {value: 'SUPPLIER_CURRENCIES', title: t('performSalesMode.SUPPLIER_CURRENCIES')},
            {value: 'CONTRACT_CURRENCY', title: t('performSalesMode.CONTRACT_CURRENCY')},
        ]
    })
</script>
